import FilterConfiguration, { isFieldFilterable } from "./Filters/FilterConfiguration";
import { FilterPopover, FilterPopoverContent, FilterPopoverWrapped } from "./Filters/FilterPopover";

export default function DashboardColumnHeader({ field }) {
    const [isOpen, setIsOpen] = useState(false)

    const filter = useSel(s => s.local.filters ? s.local.filters['field_' + field.id] : null);
    const questions = useSel(s => s.dashboard.survey.questions);
    const filterable = isFieldFilterable(field, questions);
    const isFiltered = filterable && filter && filter !== '';

    const sortingField = useSel(s => s.local.sorting?.fieldId);
    const sortingDirection = useSel(s => s.local.sorting?.direction);

    const sortingSetDirection = sortingField === field?.id ? sortingDirection : null;

    const togglePopup = (forceClose = false) => {
        setIsOpen(forceClose ? false : !isOpen);
    }

    if (!filterable) {
        return <th className="not-filterable"><span className="field-name">{field.name}</span></th>
    }

    return <th className={isFiltered ? "filtered" : ""} onClick={() => togglePopup()}>
        <FilterPopover isOpen={isOpen} filterKey={'field_' + field.id} closePopup={() => togglePopup(true)}>
            <FilterPopoverContent>
                <FilterConfiguration filterKey={'field_' + field.id} closeConfiguration={() => togglePopup(true)} />
            </FilterPopoverContent>
            <FilterPopoverWrapped>
                <span className="header-content">
                    <span className="field-name">{field.name}</span>
                    <span className={`filter-indicator ${isFiltered ? 'active' : ''}`}>
                        <SvgIconsFilter />
                    </span>
                    <span className={`sort-indicator ${sortingSetDirection ? 'active' : ''}`}>
                        <SvgIconsSort asc={sortingSetDirection === 'asc'} desc={sortingSetDirection === 'desc'} />
                    </span>
                </span>
            </FilterPopoverWrapped>
        </FilterPopover>
    </th>
}